
import GlobalContainer from './GlobalContainer';
import GlobalFlex from './GlobalFlex';

export {
    GlobalContainer as Container,
    GlobalFlex as Flex,
}